import { Controller } from 'stimulus';

const PHASE_PRE_START = 'pre_start';
const PHASE_LIVE = 'live';
const PHASE_ENDED = 'ended';

export default class extends Controller {
  static values = {
    startsAt: String,
    endsAt: String,
    preStartLabel: String,
    liveLabel: String,
    endedLabel: String,
  };

  static targets = ['countdown', 'label', 'innerCountdown'];

  #timer;
  #phase;

  connect() {
    this.#phase = this.#currentPhase();
    this.#applyPhase();

    if (this.#phase !== PHASE_ENDED) {
      this.#timer = setInterval(() => this.#checkTransition(), 1000);
    }
  }

  disconnect() {
    clearInterval(this.#timer);
  }

  // private

  #currentPhase() {
    const now = Date.now();
    const startsAt = new Date(this.startsAtValue).getTime();
    const endsAt = new Date(this.endsAtValue).getTime();

    if (now < startsAt) {
      return PHASE_PRE_START;
    } else if (now < endsAt) {
      return PHASE_LIVE;
    } else {
      return PHASE_ENDED;
    }
  }

  #checkTransition() {
    const newPhase = this.#currentPhase();
    if (newPhase !== this.#phase) {
      this.#phase = newPhase;
      this.#applyPhase();
    }
  }

  #applyPhase() {
    switch (this.#phase) {
      case PHASE_PRE_START:
        this.#showCountdown(this.preStartLabelValue, this.startsAtValue);
        break;
      case PHASE_LIVE:
        this.#showCountdown(this.liveLabelValue, this.endsAtValue);
        break;
      case PHASE_ENDED:
        this.#showEnded();
        break;
    }
  }

  #setLabel(label) {
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = label;
    }
  }

  #showCountdown(label, endsAt) {
    this.#setLabel(label);

    if (this.hasInnerCountdownTarget) {
      this.innerCountdownTarget.setAttribute('data-ui--countdown-ends-at-value', endsAt);
    }
  }

  #showEnded() {
    clearInterval(this.#timer);
    this.#setLabel(this.endedLabelValue);
  }
}
